import { render, staticRenderFns } from "./joinus.vue?vue&type=template&id=10e3abec&scoped=true"
import script from "./joinus.vue?vue&type=script&lang=js"
export * from "./joinus.vue?vue&type=script&lang=js"
import style0 from "./joinus.vue?vue&type=style&index=0&id=10e3abec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e3abec",
  null
  
)

export default component.exports